var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4066 5.85449H13.3214C11.8184 5.85449 10.3769 6.47128 9.31416 7.56918C8.25137 8.66707 7.6543 10.1561 7.6543 11.7088V58.5432C7.6543 60.0958 8.25137 61.5849 9.31416 62.6828C10.3769 63.7807 11.8184 64.3975 13.3214 64.3975H47.3241C48.8271 64.3975 50.2686 63.7807 51.3314 62.6828C52.3941 61.5849 52.9912 60.0958 52.9912 58.5432V21.9538L37.4066 5.85449Z",
    fill: "#DBE1FF",
    stroke: "#495057",
    strokeWidth: 1.91768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9883 5.85449V23.4174H52.9896",
    stroke: "#495057",
    strokeWidth: 1.91768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.ddebdc2bb663e912384bc9acf036af69.svg";
export { ForwardRef as ReactComponent };